/* istanbul ignore file */
/* eslint-disable */

let loaded = false
const BYPASS_CONSENT_COOKIE = 'bypass-cookiefirst-consent'

const LOCAL_MAPPING = {
  'vicampo.de': 'de',
  'vicampo.at': 'at',
  'vicampo.ch': 'ch',
  'vicampo.test': 'de',
  'vicampo-at.test': 'at',
  'vicampo-ch.test': 'ch'
}

const _getDevDomain = () => location.hostname?.split('.').slice(-2).join('.')
const _getTopLevelDomain = () => {
  const levels = location.hostname.split('.')
  return levels[levels.length - 1]
}

const _getCountryCode = () => {
  const devMode = import.meta.env.VITE_APP_DEV_MODE === 'ON'
  if (devMode) {
    const devDomain = _getDevDomain()
    return LOCAL_MAPPING[devDomain] || 'de'
  }
  return _getTopLevelDomain()
}

export const loadCookiefirst = async () => {
  if (
    loaded ||
    import.meta.env.VITE_APP_TRACKING_ENABLED === 'OFF' ||
    document.cookie.includes(BYPASS_CONSENT_COOKIE)
  ) {
    return
  }

  const countryCode = _getCountryCode()
  const envVariable = `VITE_APP_COOKIEFIRST_KEY_${countryCode.toUpperCase()}`
  const apiKey = import.meta.env[envVariable]
  const source = `https://consent.cookiefirst.com/sites/vicampo.${countryCode}-${apiKey}/consent.js`

  try {
    const response = await fetch(source)
    const script = await response.text()
    // eslint-disable-next-line no-new-func,no-eval
    Function(script)()
  } catch (e) {
    import.meta.env.VITE_APP_DEV_MODE === 'OFF' &&
      console.error('Failed to load cookiefirst:', e)
  }
  loaded = true
}
